import { render, staticRenderFns } from "./ExpressDialog.vue?vue&type=template&id=6da56c2e&scoped=true&lang=pug&"
import script from "./ExpressDialog.vue?vue&type=script&lang=ts&"
export * from "./ExpressDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da56c2e",
  null
  
)

export default component.exports